export function getScrollParent(node) {
  let current = node?.parentElement;
  while (current) {
    const { overflowY } = window.getComputedStyle(current);
    if (overflowY === "auto" || overflowY === "scroll") return current;
    current = current.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}

export function captureCollapseAnchor(anchor) {
  if (!anchor) return null;
  return {
    scroller: getScrollParent(anchor),
    anchor,
    anchorTop: anchor.getBoundingClientRect().top,
  };
}

export function centeredScrollTop(scroller, target, heightDelta = 0) {
  if (!scroller || !target) return 0;
  const destRect = target.getBoundingClientRect();
  const scrollerRect = scroller.getBoundingClientRect();
  const finalHeight = Math.max(0, destRect.height - heightDelta);
  const destCenter = destRect.top + finalHeight / 2;
  const viewCenter = scrollerRect.top + scroller.clientHeight / 2;
  return Math.max(0, scroller.scrollTop + (destCenter - viewCenter));
}

export function smoothScrollToCenter(scroller, target, heightDelta = 0) {
  if (!scroller || !target) return;
  const top = centeredScrollTop(scroller, target, heightDelta);
  if (Math.abs(scroller.scrollTop - top) < 12) return;
  const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  scroller.scrollTo({
    top,
    behavior: prefersReduced ? "auto" : "smooth",
  });
}

export function settleCollapseScroll(capture, target) {
  if (!capture?.scroller || !capture.anchor) return;

  const { scroller, anchor, anchorTop } = capture;
  const jump = anchor.getBoundingClientRect().top - anchorTop;
  if (jump) scroller.scrollTop += jump;

  const destination = target || anchor;
  const run = () => smoothScrollToCenter(scroller, destination);
  requestAnimationFrame(() => requestAnimationFrame(run));
}
